import React from 'react'
import { BaseSvgIcon, BaseSvgIconProps } from './base-svg-icon'

export const BarsIcon = ({
  className,
  color,
  size,
  title,
  ...rest
}: BaseSvgIconProps) => {
  return (
    <BaseSvgIcon
      className={className}
      fill="none"
      size={size}
      viewBox="0 0 16 16"
      {...rest}>
      {title && <title>{title}</title>}
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.333 1.5a.5.5 0 01.5.5v12a.5.5 0 11-1 0V2a.5.5 0 01.5-.5zM9.78 4.613a.5.5 0 01.5.5V14a.5.5 0 11-1 0V5.113a.5.5 0 01.5-.5zM6.222 7.72a.5.5 0 01.5.5V14a.5.5 0 01-1 0V8.22a.5.5 0 01.5-.5zm-3.555 3.113a.5.5 0 01.5.5V14a.5.5 0 01-1 0v-2.667a.5.5 0 01.5-.5z"
        fill={color || 'currentColor'}
      />
    </BaseSvgIcon>
  )
}
